import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MobileSidebarService {
  private isOpen$ = new BehaviorSubject<boolean>(false);

  isSidebarOpen$ = this.isOpen$.asObservable();

  open() {
    this.isOpen$.next(true);
  }

  close() {
    this.isOpen$.next(false);
  }

  toggle() {
    this.isOpen$.next(!this.isOpen$.value);
  }
}
